import script from "./Record3ChSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Record3ChSetting.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__